import { useEffect, useState } from 'react'

import { SettingsContext } from './settings-context'

function useSystemMode() {
  const [mode, setMode] = useState(() => {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return 'light'
    }

    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light'
  })

  useEffect(() => {
    if (typeof window === 'undefined' || !window.matchMedia) {
      return undefined
    }

    const media = window.matchMedia('(prefers-color-scheme: dark)')

    function onChange(event) {
      setMode(event.matches ? 'dark' : 'light')
    }

    media.addEventListener('change', onChange)
    return () => media.removeEventListener('change', onChange)
  }, [])

  return mode
}

export function SettingsProvider({ children }) {
  const systemMode = useSystemMode()
  const [themePreference, setThemePreference] = useState(() => {
    if (typeof window === 'undefined') {
      return 'system'
    }

    return localStorage.getItem('verification-frontend-theme') || 'system'
  })

  useEffect(() => {
    if (typeof window !== 'undefined') {
      localStorage.setItem('verification-frontend-theme', themePreference)
    }
  }, [themePreference])

  const mode = themePreference === 'system' ? systemMode : themePreference

  return (
    <SettingsContext.Provider value={{ themePreference, setThemePreference, mode }}>
      {children}
    </SettingsContext.Provider>
  )
}
